import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import Donations from './Donations'
import useInfiniteOrders from 'src/flp/donations/useInfiniteOrders'

const All = ({ feedUrl, more_orders_available, ...props }) => {
  const { orders, loading, refs } = useInfiniteOrders({
    orders: props.orders,
    more_orders_available,
    feedUrl,
  })

  return (
    <>
      <div ref={refs.top} className="position-relative"></div>
      <Donations orders={orders} />
      <div
        ref={refs.bottom}
        className="text-center mt-n4"
        style={{ opacity: loading ? 1 : 0, transition: 'opacity 0.1s' }}
      >
        <FontAwesomeIcon icon={faSpinner} pulse />
      </div>
    </>
  )
}

export default All
